export default "__VITE_ASSET__jBar3MzR__"